import { render } from "./Courts2.vue?vue&type=template&id=7a05efe5"
import script from "./Courts2.vue?vue&type=script&lang=js"
export * from "./Courts2.vue?vue&type=script&lang=js"

import "./Courts2.vue?vue&type=style&index=0&id=7a05efe5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__